import {
  LayoutDashboard, FileText, Receipt, ClipboardCheck, Boxes, ArrowLeftRight,
  BarChart3, Users, BookOpen, Wallet, Landmark, Package, Banknote, Settings, Printer, Calculator, Link2, ShieldCheck,
} from 'lucide-react';

// 一级：首页排最前，账套其次，其余模块顺序不变（其余先不动）
export const NAV = [
  { to: '/dashboard', label: '首页', icon: LayoutDashboard },
  { to: '/customers', label: '账套', icon: Users },
  { to: '/vouchers', label: '凭证管理', icon: FileText },
  { to: '/ledger', label: '账簿查询', icon: BookOpen },
  { to: '/invoices', label: '发票管理', icon: Receipt },
  { to: '/expenses', label: '费用单据', icon: Banknote },
  { to: '/tax-declaration', label: '税务申报', icon: ClipboardCheck },
  { to: '/payroll', label: '工资管理', icon: Wallet },
  { to: '/tax-calculator', label: '个税计算', icon: Calculator },
  { to: '/bank', label: '银行对账', icon: Landmark },
  { to: '/short-links', label: '短链管理', icon: Link2 },
  { to: '/certificates', label: '证照管理', icon: ShieldCheck },
  { to: '/statement', label: '流水生成', icon: Printer },
  { to: '/inventory', label: '进销存', icon: Package },
  { to: '/fixed-assets', label: '固定资产', icon: Boxes },
  { to: '/receivables-payables', label: '应收应付', icon: ArrowLeftRight },
  { to: '/financial-statements', label: '财务报表', icon: BarChart3 },
  { to: '/users', label: '用户管理', icon: Settings },
];

// 二级：进入账套后的核心功能（凭证/账簿/财务报表/结账/固定资产/发票/设置）
export const CORE_NAV = [
  { to: '/vouchers', label: '凭证管理', icon: FileText },
  { to: '/ledger', label: '账簿查询', icon: BookOpen },
  { to: '/financial-statements', label: '财务报表', icon: BarChart3 },
  { to: '/period-close', label: '结账', icon: ClipboardCheck },
  { to: '/fixed-assets', label: '固定资产', icon: Boxes },
  { to: '/invoices', label: '发票管理', icon: Receipt },
  { to: '/settings', label: '设置', icon: Settings },
];
